export var StringsEN = {
    // Buttons
    buttons: {
        button_logout: 'Logout',
        button_accept: 'Accept',
        button_cancel: 'Cancel',
        button_individualUsers_title: 'Individual users',
        button_individualUsers_text: 'Demo licenses, usability testers, etc.',
        button_corporateUsers_title: 'Corporate users',
        button_corporateUsers_text: 'Real licenses provided to a hospital.',
        button_analysisCount_title: 'Analysis count',
        button_analysisCount_text: 'Customer usage analysis',
        button_targetRegion: 'Target region',
        button_targetLanguage: 'Language code',
        button_createLicense: 'Create license',
        button_dbCollaborator: 'Colaborates for body composition poblational model',
        button_emailAndPasswordAuth: 'Login with email and password',
        button_passwordRotation: 'Password rotation policy (days)',
        button_dateRange: 'Date range',
        button_download: 'Download',
    },
    // Messages
    messages: {
        // Individual users
        section_newUser: 'New User',
        input_box_email: 'User',
        output_password: 'Password',
        section_existingUsers: 'Existing Users',
        info_copiedToClipboard: 'Value copied to clipboard',
        popupTitle_genericSuccess: 'Success',
        popupTitle_genericDangerous: 'Confirmation needed',
        // Corporate users
        tab_generalSettings: 'General Settings',
        tab_userSettings: 'User Settings',
        section_newDomain: 'New Domain',
        section_existingDomains: 'Existing Domain',
        input_box_adminEmail: 'Admin email',
        input_box_notificationEmail: 'Notification email',
        input_box_nDays: 'License duration (days)',
        boolean_yes: 'Yes',
        boolean_no: 'No',
        input_box_startingTimestamp: 'License created at',
        input_box_endingTimestamp: 'License ends on',
        // Licenses
        info_updatingLicense: 'Updating license...',
        info_creatingLicense: 'Creating license...',
        info_licenseCreated: 'License correctly created',
        info_gettingLicenses: 'Getting existing licenses...',
        info_deletingLicense: 'Deleting user license...',
        info_licenseDeleted: 'License correctly removed',
        confirmation_deleteLicense: 'Are you sure about removing this license?',
        confirmation_userAdded: 'User correctly added',
        confirmation_domainRemoved: 'Domain correctly removed',
        // Changes
        pupupTitle_unsavedChanges: 'Unsaved changes',
        pupupText_unsavedChanges: 'Do you want to save them?',
        // Dangerous actions
        pupupTitle_dangerousAction: 'Dangerous Action',
        pupupText_dangerousAction_deleteDomain: 'Are you sure about permanently deleting this domain?',
        // Analysis count
        cardTitle_userAnalysisCount: 'User analysis count',
        cardTitle_domainAnalysisCount: 'Domain analysis count',
        cardTitle_globalAnalysisCount: 'Global analysis count',
        cardTitle_domainActivity: 'Domain activity',
        input_box_domain: 'Domain',
        cartText_analysisCount: 'Total number of analyses performed across all domains during the selected period.',
        info_gettingInformation: 'Getting information...'
    },
    // Erros
    errors: {
        // Format (according to validators for one specific field)
        format_error_email: 'Email address badly formatted',
        format_error_nDays: 'The specified duration is not valid',
        // Standard errors      
        popupTitle_generic: 'Error',
        // License actions
        action_unableToCreateLicense: 'Unable to create license',
        action_unableToGetLicenses: 'Unable to get license list',
        action_unableToGetLicenseInformation: 'Unable to get license information',
        action_userAlreadyExists: 'User already exists',
        action_unableToUpdateLicense: 'Unable to update license',
        action_unableToDeleteDomain: 'Unable to delete domain',
    },
    // Regions
    regions: {
        eu: 'Europe (EU)',
        uk: 'United Kingdom (UK)',
        us: 'United States (US)'
    }
}